import { AUTH_SIGNOUT } from "consts/auth.consts"
import React from "react"

export const AuthenticationContext = React.createContext({
  loading: false,
  userStatus: AUTH_SIGNOUT,
  userIsDisabled: false,
})
